import { mapGetters, mapActions } from 'vuex';
import store from './store';

export default {
  props: {
    // 所属区域
    areaId: {
      type: Number,
      default: null,
    },
  },
  created() {
    store.install(this.$store);
    if (!this.areaServiceList.length) {
      this.fetchAreaServiceList({
        areaId: this.areaId,
      });
    }
    if (this.areaId) {
      this.updateFilterId(this.areaId);
    }
  },
  computed: {
    ...mapGetters('areaServiceOption', ['areaServiceList']),
  },
  watch: {
    areaId(val) {
      this.updateFilterId(val);
    },
  },
  methods: {
    ...mapActions('areaServiceOption', [
      'fetchAreaServiceList',
      'updateFilterId',
    ]),
    getServiceName(id) {
      let item = this.areaServiceList.find(service => service.serviceId === id);
      return item ? item.serviceName : '';
    },
    getServiceInfo() {
      let item = this.areaServiceList.find(service => service.serviceId === id);
      return item
        ? { serviceId: item.serviceId, serviceName: item.serviceName }
        : null;
    },
    getOperatorInfo(id) {
      let item = this.areaServiceList.find(service => service.serviceId === id);
      return item
        ? { operateId: item.operateId, operateName: item.operateName }
        : null;
    },
    getAreaInfo() {
      let item = this.areaServiceList.find(service => service.serviceId === id);
      return item ? { areaId: item.areaId, areaName: item.areaName } : null;
    },
    getAllItemInfo(id) {
      let item = this.areaServiceList.find(service => service.serviceId === id);
      return item ? item : null;
    },
  },
};
